import { render, staticRenderFns } from "./eventDetails.modal.vue?vue&type=template&id=4a8644d8&scoped=true"
import script from "./eventDetails.modal.vue?vue&type=script&lang=js"
export * from "./eventDetails.modal.vue?vue&type=script&lang=js"
import style0 from "./eventDetails.modal.vue?vue&type=style&index=0&id=4a8644d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8644d8",
  null
  
)

export default component.exports